import type { PlainFormSectionChild } from "@homebound/beam";
import type { FieldState } from "@homebound/form-state";
import { cutoffTag } from "src/routes/projects/change-events/guided/workflows/addOrModifyOptions/components/optionCardUtils";
import { OptionVariantRows } from "src/routes/projects/change-events/guided/workflows/addOrModifyOptions/components/OptionVariantRows";
import type { PackageOptionCard_CheckoutConfigOptionGroupFragment } from "src/routes/projects/change-events/guided/workflows/addOrModifyOptions/components/PackageOptionCard.generated";
import { OptionPriceMode } from "src/routes/projects/change-events/guided/workflows/components/OptionPrice";

export type PackageOptionCardProps = {
  group: PackageOptionCard_CheckoutConfigOptionGroupFragment;
  /** The form field that stores the selected package's `ReadyPlanOption` id. Picking one is required. */
  field: FieldState<string | null | undefined>;
  priceMode?: OptionPriceMode;
};

/**
 * Builds the `FormSection` child for a package option group, e.g. kitchen appliances. It shows the group's name,
 * cutoff and description, followed by one radio row per package with its price delta and product thumbnails.
 */
export function packageOptionCard(props: PackageOptionCardProps): PlainFormSectionChild {
  const { group, field, priceMode } = props;
  return {
    id: group.id,
    title: group.group.name,
    description: group.group.marketingDescription ?? undefined,
    tag: cutoffTag(group.cutoffDate),
    fields: <OptionVariantRows group={group} field={field} priceMode={priceMode} />,
  };
}
